import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import BookingForm from './widget/component/BookingForm';
import Reviews from './widget/component/Reviews';

const initGiftCardPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('booking-form', BookingForm, props);
    initWidget('reviews', Reviews, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardPageWidgets.bind(this));
} else {
    initGiftCardPageWidgets();
}